import React, { PureComponent } from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import renderCapacityIndicator from './render-capacity-indicator';

/**
 * Stled container element
 */
const Container = styled.div`
  display: flex;
  cursor: ${props =>
    props.disabled || !props.active ? 'not-allowed' : 'pointer'};
  opacity: ${props => (props.disabled ? 0.3 : 1)};
  background: ${props =>
    props.active
      ? props.isWeekday
        ? props.theme.weekday
        : props.theme.holiday
      : '#454545'};
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 0.2em 0 0.4em;
  @media (max-width: 767px) {
    padding: 0.5em 0;
  }
`;

/**
 * Container to ensure that days without capacity data render similarly
 */
const CapacityContainer = styled.div`
  display: flex;
  width: 50%;
  height: 50%;
  position: relative;
  text-align: center;
`;

/**
 * Styled heading to display date
 */
const DateText = styled.div`
  text-indent: 0.3em;
  margin: 0 0 0.1em;
`;

/**
 * Day Component
 * Displays a day with a message
 * @reactProps {object} date The date of the day being displayed
 * @reactProps {number} percent The capacity filled for that day
 * @reactProps {function(date: string): void} onClick A function called when the day is clicked
 */
class Day extends PureComponent {
  constructor(props) {
    super(props);
    /**
     * Component state
     */
    this.state = {
      isBeforeToday: this.props.date.isBefore(dayjs().startOf('day')),
      percent: null
    };
  }
  componentDidMount() {
    this.calculatePercentage();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.count !== this.props.count ||
      prevProps.capacity !== this.props.capacity
    ) {
      this.calculatePercentage();
    }
  }
  calculatePercentage() {
    // const percent = this.props.capacity
    //   ? (100 * this.props.count) / this.props.capacity
    //   : 100;
    const percent = (() => {
      if (this.props.capacity) {
        const p = (100 * this.props.count) / this.props.capacity;
        // fallthrough if overbooking is occurring
        if (p < 100) return p;
      }
      return 100;
    })();

    this.setState({ percent });
  }

  /**
   * On click callback
   */
  onClick = () => {
    if (this.state.isBeforeToday || this.state.percent === 100) {
      return;
    }
    this.props.onClick(this.props.date.toISOString());
  };

  renderIndicator = () => {
    return renderCapacityIndicator(
      this.state.percent,
      !this.state.isBeforeToday,
      this.props.loading
    );
  };

  /**
   * @inheritDoc
   */
  render() {
    const isWeekday = !(
      this.props.date.day() === 0 ||
      this.props.date.day() === 6 ||
      this.props.isHoliday
    );
    return (
      <Container
        active={this.state.percent < 100}
        disabled={this.state.isBeforeToday}
        isWeekday={isWeekday}
        onClick={this.onClick}
        style={this.props.style}
      >
        <DateText>{this.props.date.format('D')}</DateText>
        <CapacityContainer>{this.renderIndicator()}</CapacityContainer>
      </Container>
    );
  }
}

Day.propTypes = {
  date: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  count: PropTypes.number,
  capacity: PropTypes.number,
  isHoliday: PropTypes.bool,
  loading: PropTypes.bool
};

export default Day;
